import React, {useEffect, useMemo, useState} from "react";
import LoadOverlay from "../Components/SharedComponents/LoadOverlay";
import {ExcelExport} from "@progress/kendo-react-excel-export";
import {Grid, GridToolbar} from "@progress/kendo-react-grid";
import {filterBy, orderBy} from "@progress/kendo-data-query";
import {Button} from "@progress/kendo-react-buttons";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import {UserContext} from "../../contexts/UserContext";
import {semcastAxios, showErrorToastMessage} from "../../Utils/Common";
import {IDENTITY_PIPELINE} from "../../api/constants";
import {DropdownFilterCell} from "../Components/Permission/dropdownFilterCell";
import {Tooltip} from "@progress/kendo-react-tooltip";


const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "domain",
            operator: "contains",
            value: ""
        }
    ]
};

const initialSort = [
    {
        field: "created_at",
        dir: "desc"
    }
];
const dateCell = (props) => {
    // console.log("updatedCell ", props);
    const val = props.dataItem[props.field];
    let date;
    let month;
    let day;
    let year;
    if (val) {
        month = val.getMonth() + 1;
        day = val.getDate();
        year = val.getFullYear().toString().slice(-2);
        date = `${month}/${day}/${year}`
    } else {
        date = `-`
    }

    return (
        <td key={props.dataItem.id} className={"k-text-center"}>
            {date}
        </td>
    )
};

export default function AdminIdentityPipeline() {
    const {user, setUser} = React.useContext(UserContext);
    const [overlayActive, setOverlayActive] = useState(false);
    const exportExcell = React.useRef(null);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(initialFilter);
    const [sort, setSort] = useState(initialSort);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(25);

    const exportExport = () => {
        if (exportExcell.current !== null) {
            exportExcell.current.save(orderBy(filterBy(data, filter), sort));
        }
    };

    const processedData = useMemo(() => orderBy(filterBy(data, filter), sort), [data, filter, sort]);

    useEffect(() => {
        const total = processedData.length;
        if (total === 0) {
            setSkip(0);
            return;
        }
        if (skip >= total) {
            const newSkip = Math.max(total - take, 0);
            if (newSkip !== skip) {
                setSkip(newSkip);
            }
        }
    }, [processedData, skip, take]);

    //helper functions
    function formatUnixTime(unixTime) {
        if (unixTime == null) return null;

        const date = new Date(unixTime);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear().toString().slice(-2);
        return date;
    }

    function getCurrentDateTime() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        const hours = currentDate.getHours().toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');

        const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return currentDateTime;
    }

    const getIdentityPipelineData = async () => {
        try {
            let response = await semcastAxios.get(IDENTITY_PIPELINE + "/all", {withCredentials: true})
                .then((res) => {
                    let dataTemp = res.data.data;
                    dataTemp.forEach((idxTag) => {
                        idxTag.created_at = formatUnixTime(idxTag.created_at);
                        idxTag.updated_at = formatUnixTime(idxTag.updated_at);
                        idxTag.deleted_at = formatUnixTime(idxTag.deleted_at);
                        idxTag.user_name = idxTag.first_name + " " + idxTag.last_name;
                    })
                    setData(dataTemp);
                    console.log("dataTemp ", dataTemp)
                }).catch((error) => {
                    if (error.response) {
                        showErrorToastMessage("Response Error: " + error.response.data.data, 10);
                        console.log(error.response);
                    }
                    if (error.request) {
                        showErrorToastMessage("Request Error: " + error.request.data.data, 10);
                        console.log(error.request);
                    }
                });
        } catch (error) {
            console.log(error)
            showErrorToastMessage("Error accessing Tracking Pixel information. " + error);
        }
    }


    useEffect(() => {

        setOverlayActive(true);
        getIdentityPipelineData().then(() => {
            console.log("Identity Pipeline Data ", data)
        })

        setOverlayActive(false);


    }, []);

    const groupNameCell = (props) => {
        // console.log("groupNameCell ", props);
        // const groupName = getGroupNameById(groupsArr,props.dataItem.group_id);
        const groupName = props.dataItem.group_name
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {groupName}
            </td>
        )
    };
    const ftpCell = (props) => {
        // console.log("ftpCell ", props);
        // const ftpName = getFTPById(availableFTPConnections,props.dataItem.ftp_settings_id);
        const ftpName = props.dataItem.ftp_settings_name
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {ftpName}
            </td>
        )
    };
    const categoryFilterCell = props => {
        const types = Array.from(new Set(data.map(p => p[props.field] ? p[props.field] : ''))).sort((a, b) => a.localeCompare(b));
        return (
            <DropdownFilterCell {...props} data={types} defaultItem={'Select Filter...'} style={{width: 'auto'}}/>
        )
    }
    const companyCell = (props) => {
        // console.log("updatedCell ", props);
        const companyLabel = props.dataItem.company ? props.dataItem.company : "-";
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                {companyLabel}
            </td>
        )
    };
    const statusCell = (props) => {
        const statusValue = props.dataItem.status ? props.dataItem.status : "-";
        const statusMessage = props.dataItem.status_message;
        const hasStatusMessage = statusMessage !== null && statusMessage !== undefined && statusMessage !== "";
        const normalized = statusValue ? statusValue.toString().trim().toUpperCase() : "";
        let statusColor = "rgb(255, 193, 7)";
        if (normalized === "ACTIVE") {
            statusColor = "rgb(25, 135, 84)";
        } else if (normalized === "ERROR") {
            statusColor = "rgb(220, 53, 69)";
        }
        return (
            <td key={props.dataItem.id} className={"k-text-center"}>
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    color: statusColor,
                    fontWeight: 600
                }}>
                    <span>{statusValue}</span>
                    {hasStatusMessage && (
                        <Tooltip
                            position="right"
                            anchorElement="target"
                            tooltipStyle={{
                                width: "15rem",
                                borderRadius: "0.25rem",
                            }}
                        >
                            <i
                                className="fa fa-question-circle-o tooltip-question-icon"
                                aria-hidden="true"
                                title={String(statusMessage)}
                            />
                        </Tooltip>
                    )}
                </span>
            </td>
        );
    };
    return (
        <div>
            <LoadOverlay active={overlayActive} height={50} width={50}>

                <div className={"identity-pipeline-manager-outer-container"}>
                    <div className={"pipeline-grid"}>
                        <ExcelExport ref={exportExcell}
                                     fileName={`Identity Pipeline - ${user.first_name} ${user.last_name} ${getCurrentDateTime()}`}>
                            <Grid
                                data={processedData.slice(skip, skip + take)}
                                skip={skip}
                                take={take}
                                total={processedData.length}
                                filterable={true}
                                filter={filter}
                                dataItemKey={"id"}
                                autoProcessData={true}
                                onFilterChange={(e) => setFilter(e.filter)}
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => {
                                    setSort(e.sort);
                                }}
                                resizable={true}
                                style={{height: '65vh'}}
                                pageable={{buttonCount: 5, pageSizes: [10, 25, 50, 100]}}
                                onPageChange={(e) => {
                                    setSkip(e.page.skip);
                                    setTake(e.page.take);
                                }}
                            >
                                <GridToolbar>
                                    <div className={"idx-grid-toolbar-container"}>
                                        <div className={"idx-grid-toolbar-left"}>

                                        </div>
                                        <div className={"idx-grid-toolbar-right"}>
                                            <Button
                                                className={"button-standard button-white"}
                                                iconClass={"k-icon k-i-download"}
                                                onClick={exportExport}
                                            >
                                                as CSV
                                            </Button>
                                        </div>
                                    </div>
                                </GridToolbar>
                                <Column field={"id"} title={"Pipeline ID"} width={80}/>
                                {/*<Column field={"segment_naming_type"} title={"Tag Type"} cell={typeCell} filterCell={categoryFilterCell}/>*/}
                                {/*<Column field={"label"} title={"Description"} cell={labelCell} />*/}
                                <Column field={"created_at"} title={"Created"} cell={dateCell} filterable={false}/>
                                <Column field={"updated_at"} title={"Updated"} cell={dateCell} filterable={false}/>
                                <Column field={"group_name"} title={"Group"} cell={groupNameCell}
                                        filterCell={categoryFilterCell}/>
                                <Column field={"incoming_ftp_settings_name"} title={"Incoming Connection"}/>
                                <Column field={"exhaust_ftp_settings_name"} title={"Exporting Connection"}/>
                                <Column field={"status"} title={"Status"} cell={statusCell}
                                        filterCell={categoryFilterCell}/>
                                {/*<Column field={"user_name"} title={"User"} cell={nameCell} filterCell={categoryFilterCell}/>*/}
                                <Column field={"company"} title={"Company"} cell={companyCell}
                                        filterCell={categoryFilterCell}/>
                                {/*<Column cell={MyEditCommandCell} filterable={false} width={50}/>*/}
                                {/*<Column cell={SignInAsCell} filterable={false} width={125}/>*/}
                            </Grid>
                        </ExcelExport>
                    </div>
                </div>
            </LoadOverlay>
        </div>
    )
}
